import { ComponentProps } from 'react';
import { JSONTree } from 'react-json-tree';
import { twColors } from 'src/shared/lib/color.utils';

export const jsonTreeStyle = {
  scheme: 'light',
  author: 'custom',
  base00: 'transparent', // background
  base01: '#f5f5f5', // lighter background (status bar)
  base02: '#e0e0e0', // selection background
  base03: '#FFFFFF00', // comments, invisibles, line highlighting,
  base04: '#4d4d4c', // dark foreground (status bar)
  base05: '#333333', // default foreground
  base06: '#282a2e', // light foreground
  base07: '#1d1f21', // light background
  base08: '#cc6666', // variables, XML tags, markup link text, markup lists
  base09: '#de935f', // integers, boolean, constants, markup link url
  base0A: '#f0c674', // classes, markup bold, search text background
  base0B: twColors.primary, // strings, inherited class, markup code
  base0C: '#5e8d87', // support, regular expressions, escape characters, markup quotes
  base0D: twColors.slate[500], // functions, methods, attribute IDs, headings
  base0E: '#b294bb', // keywords, storage, selector, markup italic, diff changed
  base0F: '#a3685a', // deprecated, opening/closing embedded language tags
};

interface JsonViewerProps extends Omit<ComponentProps<typeof JSONTree>, 'data'> {
  children: any;
  expandAll?: boolean;
  backgroundColor?: string;
}

export default function JsonViewer({
  children,
  expandAll = true,
  backgroundColor = 'transparent',
  ...props
}: JsonViewerProps) {
  return (
    <JSONTree
      hideRoot
      theme={{
        ...jsonTreeStyle,
        base00: backgroundColor,
      }}
      data={children}
      shouldExpandNodeInitially={() => expandAll}
      {...props}
    />
  );
}
